import { useEffect, useState } from 'react'
import { getApprovalSettings, saveApprovalSettings } from '../../api/purchase'
import ErrorBanner from '../../components/ErrorBanner'
import { useToast } from '../../components/Toast.jsx'
import { BackLink, DocHeader } from '../../components/PageParts'

export default function ApprovalSettings() {
  const { notify } = useToast()
  const [limit, setLimit] = useState('0.00')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    getApprovalSettings()
      .then((data) => setLimit(Number(data?.threshold || 0).toFixed(2)))
      .catch(() => setLimit('0.00'))
  }, [])

  const save = async (e) => {
    e.preventDefault()
    const val = parseFloat(limit)
    if (Number.isNaN(val) || val < 0) { setError('Enter an amount of zero or more.'); return }
    setSaving(true)
    try {
      await saveApprovalSettings(val)
      setError('')
      notify(val > 0 ? 'Approval limit saved' : 'Approvals turned off')
    } catch (err) {
      setError(err.message || 'Could not save the approval limit.')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="ci-form-page">
      <DocHeader back={<BackLink to="/purchase/po-approval-inbox" label="Approvals" />} title="Approval limit" />
      {error && <ErrorBanner message={error} />}
      <form className="doc-card settings-form" onSubmit={save}>
        <label>
          <span>Purchase orders of this amount or more need an admin’s approval</span>
          <input value={limit} onChange={(e) => setLimit(e.target.value)} inputMode="decimal" />
        </label>
        <p className="doc-hint">Set it to 0 to let every order go straight through.</p>
        <div>
          <button type="submit" className="ci-btn ci-btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
        </div>
      </form>
    </div>
  )
}
